import { isMobile } from 'react-device-detect';

import VideoRenderer from '../videos/videoRenderer';
import WidgetRenderer from '../widgets/widgetRenderer';
import MobileAnchor from './mobileAnchor';
import React from 'react';
import $ from 'jquery';
import Swiper from 'react-id-swiper';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.goNext = this.goNext.bind(this);
    this.goPrev = this.goPrev.bind(this);
    this.swiper = null;

    this.state = {
      mainQuestionVideo: null,
      swiperQuestionVideos: [],
      initialSlideTo0: true
    };
  }

  componentWillReceiveProps() {
    const questionVideos = this.props.article.landingpage.questionVideos;
    this.setState({
      mainQuestionVideo: questionVideos[0],
      swiperQuestionVideos: questionVideos.slice(1)
    });
  }

  stageClick() {
    // open first video, rendered hidden after Swiper
    if ($('.main-question-video .video-preview').length) {
      $('.main-question-video .video-preview')[0].click();
    }
  }

  goNext() {
    if (this.swiper) {
      this.swiper.slideNext();
    }
  }

  goPrev() {
    if (this.swiper) {
      this.swiper.slidePrev();
    }
  }

  render() {
    const { article, widgets } = this.props,
          renderSwiperControls = this.state.swiperQuestionVideos.length > 2,
          videoPreviewSwiper = this.state.swiperQuestionVideos.map((questionVideo, i) => (
        <div key={i}>
          {VideoRenderer.renderVideoImage(
            questionVideo,
            questionVideo.preview,
            questionVideo.description
          )}
        </div>
      ));

    return (
      <header>
        <div
          className="background img-link"
          style={article.imageBackground}
          onClick={this.stageClick}
        >
          <div className="container">
            <div className="row">
              <aside className="sidebar">&nbsp;</aside>
              <article className="content margin-top-xlg">
                <div className="landingpage-starter">
                  {WidgetRenderer.renderWidgets(widgets, 'page-header')}
                </div>
              </article>
              <aside className="spacebar">&nbsp;</aside>
            </div>
          </div>
        </div>

        {article.landingpage.phoneNumber && <MobileAnchor article={article} />}

        <div
          className="video-content-wrapper"
          data-aos="zoom-in"
          data-aos-duration="500"
          data-aos-once="true"
        >
          {renderSwiperControls && (
            <div
              className="fotorama__arr fotorama__arr--prev hidden"
              tabIndex="0"
              role="button"
              onClick={this.goPrev}
            />
          )}

          <Swiper
            slidesPerView={isMobile ? 1 : 2}
            spaceBetween={20}
            speed={500}
            pagination={isMobile ? '.swiper-pagination' : ''}
            paginationClickable={isMobile}
            noSwiping={!isMobile}
            observer
            runCallbacksOnInit
            onInit={(swiper) => (this.swiper = swiper)}
            onSlideNextEnd={(swiper) => {
              // we do not use the swiper's 'onReachEnd' event, because there is a strange
              // behaviour on mobile. we check on ourselves for last index.
              if (
                (!isMobile && swiper.activeIndex === swiper.slides.length - 2) ||
                (isMobile && swiper.activeIndex === swiper.slides.length - 1)
              ) {
                $('.fotorama__arr--next').addClass('hidden');
              }
              // show the prev button when swiped right, because it could not be the frist slide.
              $('.fotorama__arr--prev').removeClass('hidden');
            }}
            onSlidePrevEnd={(swiper) => {
              // we do not use the swiper's 'onReachBeginning' event, because there is a strange
              // behaviour on mobile. we check on ourselves for first index.
              if (swiper.activeIndex === 0) {
                $('.fotorama__arr--prev').addClass('hidden');
              }
              // show the next button when swiped left, because it could not be the last slide.
              $('.fotorama__arr--next').removeClass('hidden');
            }}
            onAfterResize={(swiper) => {
              // on desktop there is a strange behaviour. the swiper is initially set to the
              // last slide. i think this is because of multiple component rendering. this is
              // caused by callbacks in Landingpage. the following fix slides automatically once
              // to the first slide. this is not recognizable by the visitor of the page.
              // the onAfterResize is the only event which can be used to achieve the fix.
              // after init somehow a sliding is triggered but also resize is triggered.
              // so we can act after resize and slide to the first. with setting the state
              // we make sure that it only happens once and not with every resize.
              if (this.state.initialSlideTo0) {
                swiper.slideTo(0);
                this.setState({ initialSlideTo0: false });
              }
            }}
          >
            {videoPreviewSwiper}
          </Swiper>

          {renderSwiperControls && (
            <div
              className="fotorama__arr fotorama__arr--next"
              tabIndex="0"
              role="button"
              onClick={this.goNext}
            />
          )}
        </div>
        <div className="hidden main-question-video">
          {this.state.mainQuestionVideo &&
            VideoRenderer.renderVideoImage(
              this.state.mainQuestionVideo,
              this.state.mainQuestionVideo.preview,
              this.state.mainQuestionVideo.description
            )}
        </div>
      </header>
    );
  }
}

Header.propTypes = {
  article: React.PropTypes.object,
  widgets: React.PropTypes.array
};

export default Header;



// WEBPACK FOOTER //
// ./components/landingpage/header.js